import React from 'react'
import { useProjectContext } from '../../context/ProjectContext'

const DirectionTool = ({ onClose = null }) => {
  const { selectedDirection, setSelectedDirection } = useProjectContext()

  const directions = [
    { value: 'none', label: 'X', type: 'none' },
    { value: 'up', label: 'Up', rotate: 0 },
    { value: 'down', label: 'Down', rotate: 180 },
    { value: 'left', label: 'Left', rotate: -90 },
    { value: 'right', label: 'Right', rotate: 90 },
    { value: 'up-right', label: 'Up-Right', rotate: 45 },
    { value: 'up-left', label: 'Up-Left', rotate: -45 },
    { value: 'down-right', label: 'Down-Right', rotate: 135 },
    { value: 'down-left', label: 'Down-Left', rotate: -135 },
  ]

  const handleSelect = (value) => {
    setSelectedDirection(value)
    if (onClose) onClose()
  }

  return (
    <>
      {directions.map((dir) => (
        <button
          key={dir.value}
          type="button"
          className={selectedDirection === dir.value ? 'active' : ''}
          onClick={() => handleSelect(dir.value)}
          title={dir.label}
        >
          {dir.type === 'none' ? (
            'X'
          ) : (
           <svg
  width="30"
  height="30"
  viewBox="0 0 24 24"
  style={{
    transform: `rotate(${dir.rotate}deg)`,
  }}
>
  <path
    d="M12 4 L12 20 M6 10 L12 4 L18 10"
    stroke="currentColor"
    strokeWidth="2.5"
    strokeLinecap="round"
    strokeLinejoin="round"
    fill="none"
  />
</svg>
          )}
        </button>
      ))}
    </>
  )
}

export default DirectionTool